const ORDER_STATUS_BADGE = [
  "warning",
  "success",
  "warning",
  "warning",
  "success",
  "warning",
  "success",
  "success",
  "danger",
];

const PAYMENT_STATUS_BADGE = [
  "warning",
  "success",
  "danger",
  "danger",
  "success",
];

const TRANSACTION_TYPE = [
  "CREDIT MEMO",
  "DEBIT MEMO",
  "PAID",
  "TRANSFERRED",
  "REFUND AND CANCELLATION",
  "WITHDRAWAL",
  "MONEY ADDED TO WALLET",
  "MONEY DEBITED FROM WALLET",
  "CASHBACK",
  "RECEIVED",
  "DONATION",
  "REWARD",
  "REFERRAL AMOUNT",
  "WALLET REFUND",
  "SIGN UP REWARD"
];

export { ORDER_STATUS_BADGE, PAYMENT_STATUS_BADGE, TRANSACTION_TYPE };
